export class NewsBookmarksError extends Error {
  constructor(message) {
    super(message)
    this.name = 'NewsBookmarksError'
  }
}
